module.exports = __webpack_public_path__ + "static/img/1720_phase_function_Paper_Points.4fb3de1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1720_phase_function_Paper_Points.png
// module id = TPZV
// module chunks = 0